import React from 'react';
import {
  RiskButton,
  RiskButtonRemove,
  SelectFirstNotice,
} from './v2/ResultSlotCard.styles';
import {
  updateGuaranteesAutoAction,
  updateGuaranteesMotoAction,
} from '../../../../features/insuranceRequests/insuranceRequestsActions';
import { confirmAlert } from '../../../utils/alerts';

function ButtonComponentLogicPrima({ type, processingQuote, requestInfo }) {
  const addGuarantees = (coverages) => {
    if (processingQuote.product_id === 2) {
      updateGuaranteesMotoAction(
        requestInfo.request_token,
        coverages,
        processingQuote.id,
      );
    } else {
      updateGuaranteesAutoAction(
        requestInfo.request_token,
        coverages,
        processingQuote.id,
      );
    }
  };

  const updateCoverages = (coverageSlug) => {
    const cov = processingQuote.guarantees.find(
      (c) => c.guarantees_slug === coverageSlug,
    );
    const coverages = [];
    if (cov === undefined) {
      processingQuote.guarantees.map((c) => coverages.push(c.guarantees_slug));
      if (coverageSlug === 'eventi_naturali') {
        coverages.push('eventi_sociopolitici');
      }
      if (coverageSlug === 'eventi_sociopolitici') {
        coverages.push('eventi_naturali');
      }
      coverages.push(coverageSlug);
    } else if (coverageSlug === 'eventi_naturali') {
      processingQuote.guarantees
        .filter(
          (cv) => cv.guarantees_slug !== coverageSlug
            && cv.guarantees_slug !== 'eventi_sociopolitici',
        )
        .map((c) => coverages.push(c.guarantees_slug));
    } else if (coverageSlug === 'eventi_sociopolitici') {
      processingQuote.guarantees
        .filter(
          (cv) => cv.guarantees_slug !== coverageSlug
            && cv.guarantees_slug !== 'eventi_naturali',
        )
        .map((c) => coverages.push(c.guarantees_slug));
    } else if (coverageSlug === 'furto_incendio') {
      processingQuote.guarantees
        .filter(
          (cv) => cv.guarantees_slug !== coverageSlug
            && cv.guarantees_slug !== 'eventi_naturali'
            && cv.guarantees_slug !== 'eventi_sociopolitici',
        )
        .map((c) => coverages.push(c.guarantees_slug));
    } else {
      processingQuote.guarantees
        .filter((cv) => cv.guarantees_slug !== coverageSlug)
        .map((c) => coverages.push(c.guarantees_slug));
    }

    addGuarantees(coverages);
  };

  const removeGuarantee = (coverageSlug) => {
    confirmAlert('Sei Sicuro Di Rimuovere Questo Rischio?', () => updateCoverages(coverageSlug));
  };

  // Always suffix with `_prima` — the plain `type.id` collides with the
  // generic ModalQuotes' `id={type.id}` (rendered for every entry in the
  // server-provided quoteTypes list), which sits earlier in the DOM and
  // would otherwise "win" the data-bs-target lookup, opening an empty modal.
  const createIdForModal = () => `${type?.id}_prima`;

  return (
    <div className="d-flex justify-content-end ms-auto gap-2">
      {type?.id === 'tutela_legale'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find((g) => g.guarantees_slug === type?.id) ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'tutela_legale'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === type?.id,
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'assistenza_stradale'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find((g) => g.guarantees_slug === type?.id) ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'assistenza_stradale'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === type?.id,
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'infortuni_conducente'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find((g) => g.guarantees_slug === type?.id) ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'infortuni_conducente'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === type?.id,
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'cristalli'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find((g) => g.guarantees_slug === type?.id) ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'cristalli'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === type?.id,
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'protezione_rivalse'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find((g) => g.guarantees_slug === type?.id) ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'protezione_rivalse'
        && processingQuote !== null
        && processingQuote.company_id === 2
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === type?.id,
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'kasko'
        && processingQuote.guarantees.find((g) => g.guarantees_slug === 'kasko')
        !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'kasko'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'kasko',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'collisione'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'collisione'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'eventi_sociopolitici'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'eventi_sociopolitici',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'eventi_sociopolitici'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'eventi_sociopolitici',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'eventi_naturali'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'eventi_naturali',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'eventi_naturali'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'eventi_naturali',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'bonus_protetto'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'bonus_protetto',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'bonus_protetto'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'bonus_protetto',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'furto_incendio'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'furto_incendio',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'furto_incendio'
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'furto_incendio',
        ) === undefined
        && processingQuote !== null ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'collisione_veicoli_non_assicurati'
        && processingQuote !== null
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione_veicoli_non_assicurati',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'collisione_veicoli_non_assicurati'
        && processingQuote !== null
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione_veicoli_non_assicurati',
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {type?.id === 'collisione_animali_selvatici'
        && processingQuote !== null
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione_animali_selvatici',
        ) !== undefined ? (
          <RiskButtonRemove
            className="btn btn-danger"
            onClick={() => removeGuarantee(type?.id)}
          >
            Rimuovi
          </RiskButtonRemove>
        ) : type?.id === 'collisione_animali_selvatici'
        && processingQuote !== null
        && processingQuote.guarantees.find(
          (g) => g.guarantees_slug === 'collisione_animali_selvatici',
        ) === undefined ? (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${createIdForModal()}`}
          >
            Aggiungi
          </RiskButton>
          ) : (
            ''
          )}

      {requestInfo.processing_quotation_id === null && (
        <SelectFirstNotice>
          Seleziona Prima La Responsibilita Civile
        </SelectFirstNotice>
      )}
    </div>
  );
}

export default ButtonComponentLogicPrima;
